import Vue from 'vue';
import Vuex from 'vuex';
import { Filter } from '@/shared/types/filter.class';
import { PaginateResult } from '@/shared/types/paginate-result.class';
import CategoriesService from '@/api/categories/categories.service';
import { Category } from '@/api/categories/category.model';
import Toast from '@/shared/types/toast.class';
import { ToastType } from '@/shared/types/toast-type.enum';

const categoriesService = new CategoriesService();

const state = {
  all: [],
  pagination: {},
};

const getters = {
  all: (state: any) => {
    return state.all;
  },
  pagination: (state: any) => {
    return state.pagination;
  },
};

const mutations = {
  setAll(state: any, categories: PaginateResult<Category>) {
    Vue.set(state, 'all', categories.docs);
  },
  setPagination(state: any, categories: PaginateResult<Category>) {
    Vue.set(state, 'pagination', categories);
  },
};

const actions = {
  async fetchAll(context: any, payload?: Filter): Promise<Category[]> {
    const categories = await categoriesService.fetch(payload);
    context.commit('setAll', categories);
    context.commit('setPagination', categories);
    return categories.docs;
  },
  async delete(context: any, id: string): Promise<Category> {
    try {
      return await categoriesService.delete(id);
    } catch (e) {
      context.commit('app/addToast', new Toast(e.message, ToastType.ERROR), {
        root: true,
      });
      throw e;
    }
  },
  async create(context: any, payload: Category): Promise<Category> {
    try {
      return await categoriesService.create(payload);
    } catch (e) {
      context.commit('app/addToast', new Toast(e.message, ToastType.ERROR), {
        root: true,
      });
      throw e;
    }
  },
  async update(context: any, category: Category): Promise<Category> {
    try {
      return await categoriesService.update(category._id || '', category);
    } catch (e) {
      context.commit('app/addToast', new Toast(e.message, ToastType.ERROR), {
        root: true,
      });
      throw e;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
